<template>
  <div id="articulos" v-on:keyup.esc="cerrarModal" tabindex="-1">
    <div id="blur" :disable="disable">
      <form class="form-inline" style="margin:10px auto;">
        <div class="form-group" style="margin:0 auto;">
          <select
            v-model="selectBusqueda"
            class="form-control input-group-text"
            style="max-width:400px;min-width:200px"
            :disabled="mostrarModal"
          >
            <option v-for="(busq,index) in select" :key="index" :value="busq.valor">{{busq.nombre}}</option>
          </select>
          <div class="col" style="padding:0px;">
            <input
              type="text"
              class="form-control"
              id="busqueda"
              style="max-width:1000px;min-width:200px"
              required
              :disabled="mostrarModal"
            />
          </div>
          <button
            style="margin-left:5px; margin-top:0px"
            class="btn btn-info"
            type="submit"
            @click.prevent="realizarBusqueda"
            :disabled="mostrarModal"
          >
            <i class="fa fa-search" style="display: inline;"></i>
            {{$i18n.t('search')}}
          </button>
          <button
            @click.prevent="limpiarFiltro"
            class="btn btn-info"
            style="margin-left:5px"
            :title="$i18n.t('cleanGrid')"
          >
            <i class="fa fa-eraser"></i>
          </button>
        </div>
      </form>
      <dx-data-grid
        :data-source="dataSource"
        ref="grillaArticulo"
        :loadPanel="loadPanel"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-min-width="20"
        :show-borders="true"
        :disabled="mostrarModal"
        :remote-operations="remote"
        :allow-filter="true"
        :headerFilter="headerFilter"
        :repaint-changes-only="true"
        :filterRow="filterRow"
        :noDataText="$i18n.t('tabla.nodata')"
        :columnAutoWidth="true"
        :height="500"
        :columnFixing="columnFixing"
        :selection="selection"
        :stateStoring="storage"
        :columnChooser="columnChooser"
        :grouping="grouping"
        :sorting="sorting"
      >
        <dx-column
          :caption="this.$i18n.t('articulo.columns.cod')" 
          data-field="codigo"
          :allow-header-filtering="false"
        />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.id')"
          data-field="id"
          :allow-header-filtering="false"
          alignment="left"
        ></dx-column>
        <dx-column
          :caption="this.$i18n.t('articulo.columns.cod_externo')"
          data-field="codigo_externo"
          :allow-header-filtering="false"
        />
        <dx-column
          :width="100"
          :allow-sorting="false"
          :allow-filtering="false"
          data-field="bucket_id"
          :caption="this.$i18n.t('articulo.columns.preview')"
          cell-template="cellTemplate"
          alignment="left"
        />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.calc_desc')"
          data-field="calc_desc"
          :allow-header-filtering="false"
        />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.desc_etiqueta')"
          :allow-header-filtering="false"
          data-field="desc_etiqueta"
          :visible="false"
        />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.desc_imp_fiscal')"
          data-field="desc_imp_fiscal"
          :allow-header-filtering="false"
          :visible="false"
        />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.desc')"
          data-field="descripcion"
          :allow-header-filtering="false"
          :visible="false"
        />
        <dx-column :caption="this.$i18n.t('articulo.columns.marca')" data-field="marca.nombre" />
        <dx-column :caption="this.$i18n.t('articulo.columns.medida')" data-field="medida" />
        <dx-column :caption="this.$i18n.t('articulo.columns.modelo')" data-field="modelo" />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.familia')"
          data-field="familia.descripcion"
        />
        <dx-column :caption="this.$i18n.t('articulo.columns.grupo')" data-field="grupo.nombre" />
        <dx-column
          :caption="this.$i18n.t('articulo.columns.info')"
          type="buttons"
          cssClass="botonestd"
          :buttons="buttons"
        />
        <div style="height:80px" slot="cellTemplate" slot-scope="{ data }">
          <slider :id="data.value" />
        </div>
        <dx-paging :page-size="50" :visible="true" :page-index="0" />
        <dx-pager :show-page-size-selector="true" :visible="true" :show-info="true" />
      </dx-data-grid>
      <dx-button
        @click="abrirModal"
        :text="this.$i18n.t('btn.upload')"
        type="default"
        icon="upload"
        style="margin:15px 0px"
        :disabled="$refs['grillaArticulo'] != undefined && $refs['grillaArticulo'].instance.getSelectedRowsData()>0"
      ></dx-button>
    </div>
    <modal
      v-if="mostrarModal"
      :articulosId="$refs['grillaArticulo'].instance.getSelectedRowsData()"
      style="position:absolute;z-index:2"
      class="w3-display-middle"
      id="modal"
      ref="modalSubida"
    ></modal>
  </div>
</template>
<script>
/* eslint-disable no-console */
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging
} from "devextreme-vue/data-grid";
import $ from "jquery";
import CustomStore from "devextreme/data/custom_store";
import modal from "../components/modal";
import slider from "../components/slider";
import { DxButton } from "devextreme-vue";
import notify from "devextreme/ui/notify";

export default {
  name: "articulos",
  components: {
    DxDataGrid,
    modal,
    slider,
    DxColumn,
    DxButton,
    DxPager,
    DxPaging
  },
  data() {
    return {
      dataSource: [],
      headerFilter: {
        visible: true,
        texts: {
          cancel: this.$i18n.t("tabla.cancel"),
          emptyValue: this.$i18n.t("tabla.emptyValue"),
          ok: this.$i18n.t("tabla.ok")
        }
      },
      sorting: {
        ascendingText: this.$i18n.t("tabla.ord_asc"),
        clearText: this.$i18n.t("tabla.clearText"),
        descendingText: this.$i18n.t("tabla.descendingText")
      },
      columnChooser: {
        allowSearch: false,
        enabled: true,
        height: 260,
        mode: "select",
        searchTimeout: 500,
        title: "Columnas a mostrar..",
        width: 250
      },
      storage: {
        enabled: true,
        type: "localStorage",
        storageKey: "grillaArticulos"
      },
      filterRow: {
        applyFilterText: this.$i18n.t("tabla.applyFilterText"),
        betweenEndText: this.$i18n.t("tabla.betweenEndText"),
        betweenStartText: this.$i18n.t("tabla.betweenStartText"),
        operationDescriptions: {
          between: this.$i18n.t("tabla.between"),
          contains: this.$i18n.t("tabla.contains"),
          endsWith: this.$i18n.t("tabla.endsWith"),
          equal: this.$i18n.t("tabla.equal"),
          greaterThan: this.$i18n.t("tabla.greaterThan"),
          greaterThanOrEqual: this.$i18n.t("tabla.greaterThanOrEqual"),
          lessThan: this.$i18n.t("tabla.lessThan"),
          lessThanOrEqual: this.$i18n.t("tabla.lessThanOrEqual"),
          notContains: this.$i18n.t("tabla.notContains"),
          notEqual: this.$i18n.t("tabla.notEqual"),
          startsWith: this.$i18n.t("tabla.startsWith")
        },
        resetOperationText: this.$i18n.t("tabla.reset"),
        visible: true,
        applyFilter: "auto"
      },
      grouping: {
        allowCollapsing: true,
        contextMenuEnabled: true,
        expandMode: "rowClick",
        texts: {
          groupByThisColumn: this.$i18n.t("tabla.groupByThisColumn"),
          groupContinuedMessage: this.$i18n.t("tabla.groupContinuedMessage"),
          groupContinuesMessage: this.$i18n.t("tabla.groupContinuesMessage"),
          ungroup: this.$i18n.t("tabla.ungroup"),
          ungroupAll: this.$i18n.t("tabla.ungroupAll")
        }
      },
      columnFixing: {
        enabled: true,
        texts: {
          fix: this.$i18n.t("tabla.fix"),
          leftPosition: this.$i18n.t("tabla.leftPosition"),
          rightPosition: this.$i18n.t("tabla.rightPosition"),
          unfix: this.$i18n.t("tabla.unfix")
        }
      },
      remote: { paging: true },
      select: [
        {
          valor: "desc_mod_med",
          nombre: this.$i18n.t("option.desc")
        },
        {
          valor: "codigo",
          nombre: this.$i18n.t("option.cod")
        },
        {
          valor: "cod_externo",
          nombre: this.$i18n.t("option.cod_externo")
        },
        {
          valor: "marca",
          nombre: this.$i18n.t("option.marca")
        },
        {
          valor: "modelo",
          nombre: this.$i18n.t("option.modelo")
        },
        {
          valor: "medida",
          nombre: this.$i18n.t("option.medida")
        },
        {
          valor: "ean",
          nombre: this.$i18n.t("option.ean")
        },
        {
          valor: "alias",
          nombre: this.$i18n.t("option.alias")
        }
      ],
      selectBusqueda: "desc_mod_med",
      mostrarModal: false,
      busqueda: "",
      disable: false,
      buttons: [
        {
          icon: "fas fa-info",
          hint: "ver",
          text: "ver",
          cssClass: "buttonInfo",
          onClick: e => {
            this.$router.push({
              name: "previewArticulo",
              params: { id: e.row.data.id, lang: this.$i18n.locale }
            });
          }
        }
      ],
      pager: {
        showPageSizeSelector: true,
        showNavigationButtons: true,
        visible: true,
        showInfo: true,
        pageSizes: [5, 20, 50]
      },
      loadPanel: {
        text: this.$i18n.t("modal.loading")
      },
      selection: {
        allowSelectAll: true,
        deferred: false,
        mode: "multiple",
        selectAllMode: "page",
        showCheckBoxesMode: "always"
      },
      paging: {
        pageSize: 100,
        visible: true,
        pageIndex: 0
      }
    };
  },
  methods: {
    abrirModal() {
      console.log("ENTRO ABRIR EL MODAL --------------");
      if (this.$refs["grillaArticulo"] != undefined) {
        if (
          this.$refs.grillaArticulo.instance.getSelectedRowsData().length > 0
        ) {
          this.mostrarModal = !this.mostrarModal;
          $("#blur").css("filter", "blur(4px)");
          this.disable = true;
        } else {
          notify(this.$i18n.t("error.selection"), "warning", 5000);
        }
      } else {
        notify(this.$i18n.t("error.selection"), "warning", 5000);
      }
    },
    cerrarModal() {
      console.log("ENTRO CERRAR EL MODAL --------------");
      this.mostrarModal = false;
      $("#blur").css("filter", "blur(0px)");
      // this.$refs.articulosSubir.instance.reload();
      this.$refs["grillaArticulo"].instance.refresh();
      this.disable = false;
    },
    realizarBusqueda() {
      this.busqueda = document.getElementById("busqueda").value;
      sessionStorage.setItem("busquedaArticulos", this.busqueda);
      sessionStorage.setItem("selectBusqueda", this.selectBusqueda);
      this.consultaArt();
    },
    consultaArt() {

      console.log("ESTA REALIZANDO LA BUSQUEDA DE ARTICULOS ----------------------------------");
      var self = this;

      self.dataSource = {
        store: new CustomStore({
          type: "odata",
          key: "id",
          load: function(loadOptions) {
            let params = "?";

            var request = {
              crossDomain: true,
              headers: {
                EmpID: sessionStorage.getItem("empId"),
                Authorization:
                  "Basic " +
                  btoa(
                    sessionStorage.getItem("usuario") +
                      ":" +
                      sessionStorage.getItem("clave")
                  )
              }
            };

            var deferred = $.Deferred();
            params += `&size=${loadOptions.take || 100}`;
            params += `&page=${loadOptions.skip / loadOptions.take || 0}`;
            params += `&${sessionStorage.getItem(
              "selectBusqueda"
            )}=${encodeURIComponent(self.busqueda)}`;
            params += `&grupo_id=${encodeURIComponent("ME,AL")}`;
            // params += '&limit=' + loadOptions.take;
            // params += '&offset=' + loadOptions.skip;
            self.$http
              .get(
                `${self.$store.getters.ws.api_paljet}/articulos${params}`,
                request
              )
              .then(async response => {
                if (response.data.name) {
                  await self.$nextTick(() => {
                    notify(
                      self.$i18n.t("art.resErr"),
                      // "",
                      // { shading: true },
                      "warning",
                      5000
                    );
                  });
                  deferred.resolve({ data: [], totalCount: 0, totalPages: 0 });
                } else {
                  self.page = response.data.number;
                  await deferred.resolve({
                    data: response.data.content.map(x => x),
                    totalCount: response.data.totalElements,
                    totalPages: response.data.totalPages
                  });
                }
              })
              .catch(err => {
                console.log(err);
              });
            return deferred.promise();
          }
        })
      };
      
    },
    isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    limpiarFiltro() {
      this.$refs["grillaArticulo"].instance.clearFilter();
    }
  },
  mounted() {
    /*eslint no-empty: "error"*/
    if (
      sessionStorage.getItem("busquedaArticulos") != "" ||
      sessionStorage.getItem("busquedaArticulos") != undefined ||
      sessionStorage.getItem("busquedaArticulos") != null
    ) {
      /*eslint no-empty: "error"*/
    } else {
      this.busqueda = sessionStorage.getItem("busquedaArticulos");
      document.getElementById("busqueda").value = this.busqueda;
      this.selectBusqueda = sessionStorage.getItem("selectBusqueda");
      this.consultaArt();
    }
  }
};
</script>
<style>
@import url("../css/w3.css");
.red {
  color: red !important;
}
#articulos {
  margin: 4%;
  margin-top: 0px;
}
.buttonInfo {
  font-size: 20px;
}
.invalid-feedback {
  display: block !important;
}
</style>
